// ABOUTME: Drops every Cache Storage entry of the origin (used by the app reload path)
// ABOUTME: Errors are logged, never thrown — a failed cleanup must not block a reload

import { addLogDebug, addLogError } from "@/model/logger"

export const clearCaches = async () => {
  try {
    if ("caches" in window) {
      const cacheNames = await caches.keys()
      await Promise.all(cacheNames.map((name) => caches.delete(name)))
      addLogDebug("Caches cleared")
    }
  } catch (e) {
    addLogError("Error clearing caches", e)
  }
}
